import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { ClientStore } from 'src/app/stores/stores';
import { SelectedStoreState } from '../../+state/stores.reducer';
import { getSelectedStore, getSelectedStoreLoadingFrequency } from '../../+state/stores.selectors';
import { filter, takeUntil } from 'rxjs/operators';
import { HelperService } from 'src/app/public/helper.service';
import { CheckoutService } from '../../store-checkout/checkout.service';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { Capacitor } from '@capacitor/core';
import { OpenTimeModalComponent } from '../open-time-modal/open-time-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { WhitelabelService } from 'src/app/shared/whitelabel.service';
import { LocationService } from '../../../location.service';
import { Location } from '@angular/common';
import { CustomerAuthService } from 'src/app/public/customer-auth.service';

@Component({
  selector: 'app-store-page-header',
  templateUrl: './store-page-header.component.html',
  styleUrls: ['./store-page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorePageHeaderComponent implements OnInit, AfterViewChecked, OnDestroy {
  selectedStore$: Observable<ClientStore>;
  selectedStore: ClientStore;
  unsubscribe$: Subject<void> = new Subject<void>();
  openTimeModal: Subject<any> = new Subject();

  @ViewChild('pageHeaderContainerElement') pageHeaderContainerElement: ElementRef<HTMLDivElement>;

  pageHeaderContainerHeight: number = 0;

  backgroundMargin = 200;
  logoMargin = 60;
  logoBackgrondColor = 'rgba(0,0,0,1)';
  isDark = true;
  isIOSApp: boolean = false;

  openTimeSchedule: any;
  @Output() isLoadingStatus = new EventEmitter<boolean>();
  poweredBy: string;
  commercialUrl: string;
  whiteLabelName: string;

  constructor(
    private helper: HelperService,
    private store: Store<SelectedStoreState>,
    private checkoutService: CheckoutService,
    private ngZone: NgZone,
    private dialogService: MatDialog,
    private cdr: ChangeDetectorRef,
    private whitelabelService: WhitelabelService,
    private locationService: LocationService,
    private location: Location
  ) { }

  ngOnInit() {
    this.isIOSApp = Capacitor.getPlatform() === 'ios';

    this.selectedStore$ = this.store.pipe(select(getSelectedStore));

    this.selectedStore$.pipe(takeUntil(this.unsubscribe$)).subscribe((selectedStore) => {
      this.selectedStore = selectedStore;

      const openingHoursSchedule = this.selectedStore?.specialSchedules?.find((s) => s.type === 'OPENING_HOURS');
      this.openTimeSchedule = openingHoursSchedule
        ? this.helper.processOpenTimeSchedule(
            openingHoursSchedule.schedule,
            this.selectedStore.timeZone,
            this.selectedStore?.settings?.TIME_FORMAT_SELECTION,
            this.selectedStore?.locale
          )
        : undefined;
    });

    this.commercialUrl = this.whitelabelService.getWhitelabelCommericalUrl();
    this.poweredBy = this.whitelabelService.getWhitelabelPoweredBy();
    this.whiteLabelName = this.whitelabelService.getWhiteLabelName();

    this.store
      .pipe(
        takeUntil(this.unsubscribe$),
        select(getSelectedStoreLoadingFrequency),
        filter(d => !!d)
      )
      .subscribe((d) => {
      if (this.checkoutService.ifStoreClosed() && !this.checkoutService.isFutureOrderingEnabled()) {
        this.dialogService.open(OpenTimeModalComponent, {
          data: {
            schedule: this.openTimeSchedule,
            tab: 'openTimes',
            selectedStore: this.selectedStore,
            isClosedForOrdering: true
          }
        });
      }
    });
  }

  isLoadingEmitter(event: boolean){
    this.isLoadingStatus.emit(event);
  }
  ngAfterViewChecked(): void {
    this.ngZone.run(() => {
      if (this.pageHeaderContainerHeight !== (this.getPageHeaderContainerRect().height)) {
        this.pageHeaderContainerHeight = this.getPageHeaderContainerRect().height;
        this.cdr.detectChanges();
      }
    })
  }
  isSocialMediaHandlePresent() {
    if (this.selectedStore.settings.STORE_WEBSITE_URL || this.selectedStore.settings.FACEBOOK_URL || this.selectedStore.settings.INSTAGRAM_URL || this.selectedStore.settings.TIKTOK_URL || this.selectedStore.settings.TWITTERX_URL || this.selectedStore.settings.CARDITIO_URL
    ) {
      return true;
    }
    return false;
  }
  isReviewMediaHandlePresent() {
    if (this.selectedStore.settings.GOOGLE_BUSINESS_PAGE_URL ||
      this.selectedStore.settings.TRIP_ADVISOR_URL
    ) {
      return true;
    }
    return false;
  }

  onOpenTimeModal(event: any, tab: string) {
    event.preventDefault();
    this.dialogService.open(OpenTimeModalComponent, {
      data: {
        schedule: this.openTimeSchedule,
        tab,
        selectedStore: this.selectedStore,
        isClosedForOrdering: this.checkoutService.isClosedForOrdering()
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  isClosedForOrdering() {
    return this.checkoutService.isClosedForOrdering();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    this.ngAfterViewChecked();
  }

  private getPageHeaderContainerRect() : DOMRect {
    return this.pageHeaderContainerElement?.nativeElement?.getBoundingClientRect();
  }

  shouldDisplaySiblingSelection() {
    return this.selectedStore?.relation?.siblingStores?.some((sibling) => !sibling.isIndependent);
  }


  OnGoBack(event) {
    event.preventDefault();
    this.locationService.goBack();
  }
}
